export const qandAlInfoSelector = state => state.qandaInfo;
